import { Box, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { CloseIcon } from '$common/icons/close'
import { ForwardContent } from './components'

const StyledBox = styled(Box)`
  display: flex;
  /* @noflip */
  padding: 5px 4px 4px 12px;
  background-color: white;
  /* @noflip */
  border-radius: 8px 8px 0 0;
  z-index: 1;
  align-items: center;
  gap: 4px;
`

interface Props {
  roomId: string
  iids: number[]
  onCancel: () => any
}
export function ForwardPreview({ iids, roomId, onCancel }: Props) {
  return (
    <StyledBox>
      <IconButton onClick={onCancel}>
        <CloseIcon sx={{ color: 'gray' }} />
      </IconButton>
      <ForwardContent roomId={roomId} iids={iids} />
    </StyledBox>
  )
}
